import { useContext } from 'react';
import SettingsContext from '../../src/components/context/SettingsContext';

const useSettings = () => useContext(SettingsContext);

export default useSettings;
